import jwt from "jsonwebtoken";

export default {
  data() {
    return {
      employeeBrandingData: {
        attachment_employee_branding_photo_url: '',
        employee_name: '',
        employee_position: '',
        testimonial: '',
        status: 'ACTIVE',
        priority: "0"
      },
      optionsStatus: ["ACTIVE", "INACTIVE"],
      url: null,
      showErrorField: false,
      imageDimension: {}
    }
  },
  mounted() {
    this.authentication()
  },
  computed: {
    validate() {
      return {
        employee_name: {
          isValid: this.checkIsValid(this.employeeBrandingData.employee_name),
          error: !this.employeeBrandingData.employee_name,
          message: "Name harus diisi"
        },
        employee_position: {
          isValid: this.checkIsValid(this.employeeBrandingData.employee_position),
          error: !this.employeeBrandingData.employee_position,
          message: "Position harus diisi"
        },
        testimonial: {
          isValid: this.checkIsValid(this.employeeBrandingData.testimonial),
          error: !this.employeeBrandingData.testimonial,
          message: "Testimonial harus diisi"
        },
        status: {
          isValid: this.checkIsValid(this.employeeBrandingData.status),
          error: !this.employeeBrandingData.status,
          message: "Status harus diisi"
        },
        attachment_employee_branding_photo_url: {
          ...this.decideImageError()
        }
      }
    },
    errorForms() {
      return Object.values(this.validate).filter((form) => form.error === true)[0]
    },
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "HRD" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    async handleImage(event) {
      if (event.length) {
        const file = event[0]
        this.url = URL.createObjectURL(file)
        this.imageDimension = await this.addImageProcess(this.url)
        this.employeeBrandingData.attachment_employee_branding_photo_url= file
      }
    },
    decideImageError() {
      if (!this.employeeBrandingData.attachment_employee_branding_photo_url) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "Image harus diisi"
        }
      }
      if (this.employeeBrandingData.attachment_employee_branding_photo_url && 
        this.employeeBrandingData.attachment_employee_branding_photo_url["size"] > 150000
      ) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "File size should be below 150KB"
        }
      }
      if (
        (this.imageDimension.width !== 310) ||
        (this.imageDimension.height !== 465)
        ) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "Picture must be size is 310px x 465px"
        }
      } 
      return {
        error: false,
        isValid: null,
        message: ""
      }
    },
    checkIsValid(val) {
      return this.showErrorField && !val ? false : null
    },
    addImageProcess(src){
      return new Promise((resolve, reject) => {
        let img = new Image()
        img.onload = () => resolve({width: img.width, height: img.height})
        img.onerror = reject
        img.src = src
      })
    },
    goBack() {
      this.$router.push({ path: "/career/employee-branding" })
    }
  },
}
